import { render, staticRenderFns } from "./CompanyCustomerAddressForm.vue?vue&type=template&id=572f7b6d&"
import script from "./CompanyCustomerAddressForm.vue?vue&type=script&lang=js&"
export * from "./CompanyCustomerAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports